import { getUserById } from "@/helpers/userHelper";
import moment from "moment";
import POIStep from "@/components/POI/POIStep/POIStep.vue";
import LogOverview from "@/components/Common/LogOverview/LogOverview.vue";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);
import { aiAttributionItems } from "@/helpers/commonHelper";

export default {
  name: "ProcessingStatus",
  components: { POIStep, LogOverview },
  props: [
    "editedItem",
    "step",
    "position",
    "principals",
    "isAdmin",
    "isOwnedBySubPrincipal"
  ],
  data: () => ({
    user: null,
    aiAttributionItems
  }),
  async mounted() {
    const id = this.editedItem.updatedBy;
    if (id)
      try {
        this.user = await getUserById(this.editedItem.updatedBy);
      } catch (ex) {
        console.error(ex);
      }
  },
  methods: {
    changeStep(position) {
      this.$emit("changeStep", position);
    },
    formatDate(date) {
      return moment(date).format("DD.MM.YYYY HH:mm");
    }
  },
  computed: {
    editedItemAiAttribution: {
      get() {
        return this.editedItem?.ai_attribution ?? "";
      },
      set(value) {
        this.$set(this.editedItem, "ai_attribution", value ?? "");
      }
    },
    isRegion() {
      return (
        this.$store.state.currentUser?.principal_id === this.REGION_PRINCIPAL
      );
    },
    logUrl() {
      return `${env.poi_api_client_url}log/${this.editedItem._id}`;
    }
  }
};
